export class MatchedAddress {
  constructor() { }
  singleLine: string;
  postcode: string;
  resultId: string;
}

export class FullAddress {
  constructor() { }
  poBox: string;
  subBuildingNumber: string;
  subBuildingName: string;
  buildingName: string;
  buildingNumber: string;
  street: string;
  district: string;
  city: string;
  county: string;
  postcode: string;
}
